import { TriangleAlert } from "lucide-react";
import { useTranslate } from "ra-core";

import { Badge } from "@/components/ui/badge";

/**
 * "Revisar unidad de negocio" marker for a legacy person stored as 'ambos'
 * (EC2c): icon plus text, never colour alone, shown until Direccion picks
 * Corretaje or BPO.
 */
export const BusinessUnitReviewBadge = () => {
  const translate = useTranslate();
  return (
    <Badge variant="destructive" className="gap-1">
      <TriangleAlert aria-hidden="true" className="size-3" />
      {translate("resources.sales.fields.business_arm_review")}
    </Badge>
  );
};
